import './style.css';
import { render as renderToday }    from './views/Today.js';
import { render as renderStats }    from './views/Stats.js';
import { render as renderSettings } from './views/Settings.js';

// ── PWA Service Worker ────────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// ── Router ────────────────────────────────────────────────────
const views = { today: renderToday, stats: renderStats, settings: renderSettings };
const container = document.getElementById('view-container');
const navBtns   = document.querySelectorAll('.nav-btn');

function getRoute() {
  return (location.hash.replace('#', '') || 'today');
}

function navigate(route) {
  if (!views[route]) route = 'today';
  container.innerHTML = '';
  views[route](container);
  navBtns.forEach(btn => {
    btn.classList.toggle('active', btn.dataset.route === route);
  });
}

navBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    location.hash = btn.dataset.route;
  });
});

window.addEventListener('hashchange', () => navigate(getRoute()));
navigate(getRoute());
